// Dropdowns and the mobile menu are native <details>; close them on outside click, Escape, or when another opens
const menus = () => document.querySelectorAll('.site-header details[open]');

document.addEventListener('click', (event) => {
    menus().forEach((menu) => {
        if (!menu.contains(event.target)) {
            menu.removeAttribute('open');
        }
    });
});

document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
        menus().forEach((menu) => menu.removeAttribute('open'));
    }
});

document.querySelectorAll('.site-header details').forEach((details) => {
    details.addEventListener('toggle', () => {
        if (details.open) {
            menus().forEach((menu) => {
                if (menu !== details && !menu.contains(details)) {
                    menu.removeAttribute('open');
                }
            });
        }
    });
});

// Slide the header away while scrolling down and bring it back on any scroll up
const header = document.querySelector('.site-header');
let lastScrollY = window.scrollY;
let ticking = false;

window.addEventListener('scroll', () => {
    if (ticking || !header) {
        return;
    }
    ticking = true;
    requestAnimationFrame(() => {
        const scrollY = window.scrollY;
        const scrollingDown = scrollY > lastScrollY;

        if (Math.abs(scrollY - lastScrollY) > 6) {
            header.classList.toggle('is-hidden', scrollingDown && scrollY > header.offsetHeight * 2 && menus().length === 0);
            lastScrollY = scrollY;
        }
        ticking = false;
    });
}, { passive: true });

// Ads: only fill slots that are visible (the sidebar slot is hidden on mobile)
document.querySelectorAll('ins.adsbygoogle').forEach((slot) => {
    if (slot.offsetWidth === 0) {
        slot.closest('.ad-slot')?.remove();
        return;
    }
    (window.adsbygoogle = window.adsbygoogle || []).push({});
});

// Cookie notice
const cookieName = 'euCookieLawPassed';

if (!document.cookie.split('; ').some((cookie) => cookie.startsWith(cookieName + '='))) {
    const notice = document.createElement('div');
    notice.className = 'cookie-notice';
    notice.setAttribute('role', 'region');
    notice.setAttribute('aria-label', 'Cookie notice');
    notice.innerHTML = '<p>This website uses cookies to ensure you get the best experience on our website.</p>'
        + '<div><button type="button">Got it</button><a href="/policies">Learn more</a></div>';
    notice.querySelector('button').addEventListener('click', () => {
        document.cookie = cookieName + '=true; max-age=' + 60 * 60 * 24 * 365 + '; path=/; SameSite=Lax';
        notice.remove();
    });
    document.body.append(notice);
}

// Contact form: posts to the API so it still works on cached pages
const contactForm = document.querySelector('[data-contact-form]');

if (contactForm) {
    const started = Date.now();
    const errorBox = document.querySelector('[data-contact-error]');
    const showError = (message) => {
        errorBox.textContent = message;
        errorBox.hidden = false;
    };

    contactForm.addEventListener('submit', async (event) => {
        event.preventDefault();
        errorBox.hidden = true;

        if (!contactForm.checkValidity()) {
            contactForm.reportValidity();
            return;
        }

        const button = contactForm.querySelector('button[type="submit"]');
        button.disabled = true;

        const data = Object.fromEntries(new FormData(contactForm));
        data.started = started;
        data.page_url = document.referrer.startsWith(location.origin) ? document.referrer : null;

        try {
            const response = await fetch('/api/contact', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify(data),
            });

            if (response.ok) {
                contactForm.hidden = true;
                document.querySelector('[data-contact-success]').hidden = false;
                return;
            }

            if (response.status === 429) {
                showError('You have sent a few messages already. Please try again in a few minutes.');
            } else if (response.status === 422) {
                const body = await response.json();
                showError(Object.values(body.errors ?? {}).flat()[0] ?? 'Please check the form and try again.');
            } else {
                showError('Sorry, something went wrong. Please try again.');
            }
        } catch {
            showError('Sorry, something went wrong. Please check your connection and try again.');
        }

        button.disabled = false;
    });
}

// Page views (App\Services\PageViews): reported once someone is reading, so bots posing as browsers aren't counted.
// That's the first scroll, tap, click or key press, or 10 seconds with the page in view, never from an automated
// browser. A visit counts from the page someone arrives on from outside; a click from another page on the site only
// counts if they arrived that way earlier in the same browser session.
const sameSite = (host) => host.replace(/^(www|dev)\./, '') === location.hostname.replace(/^(www|dev)\./, '');
const fromThisSite = (() => {
    try {
        return document.referrer !== '' && sameSite(new URL(document.referrer).hostname);
    } catch {
        return false;
    }
})();
const visitCookie = 'visit';
const visiting = document.cookie.split('; ').some((cookie) => cookie.startsWith(visitCookie + '='));

if (!fromThisSite) {
    // Ends when the browser closes; holds no information about the visitor
    document.cookie = visitCookie + '=1; path=/; SameSite=Lax';
}

if ('countView' in document.body.dataset && !navigator.webdriver && (!fromThisSite || visiting)) {
    const signals = ['scroll', 'pointerdown', 'keydown', 'touchstart'];
    let counted = false;
    let timer = null;

    const count = () => {
        if (counted) {
            return;
        }
        counted = true;
        clearTimeout(timer);
        signals.forEach((signal) => window.removeEventListener(signal, count, true));
        document.removeEventListener('visibilitychange', timeInView);

        fetch('/api/view', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json; charset=UTF-8' },
            body: JSON.stringify({
                id: parseInt(document.body.dataset.pageId, 10) || null,
                language: document.body.dataset.language,
                path: location.pathname,
                referrer: document.referrer,
            }),
            keepalive: true,
        }).catch(() => {});
    };

    // The 10 seconds only run while the page is in view, so a background tab or a prerender doesn't count
    const timeInView = () => {
        clearTimeout(timer);
        if (document.visibilityState === 'visible') {
            timer = setTimeout(count, 10000);
        }
    };

    signals.forEach((signal) => window.addEventListener(signal, count, { capture: true, passive: true }));
    document.addEventListener('visibilitychange', timeInView);
    timeInView();
}
